import React, { ReactElement, useEffect } from 'react'
import Divider from '../Divider'
import StatsOverview from './StatsOverview'

const StatsPanel = (): ReactElement => {
    useEffect(() => {
        window.location.hash = `#stats`
    }, [])

    return (
        <div className="panel">
            <Divider />
            <StatsOverview />
        </div>
    )
}

export default StatsPanel
